import { ExperimentsHome } from '@devtinker/experiments';
import React from 'react';

const Experiments: React.FC = () => {
  return (
    <ExperimentsHome
      contentfulSpaceId={import.meta.env.VITE_CONTENTFUL_SPACE_ID}
      contentfulAccessToken={import.meta.env.VITE_CONTENTFUL_ACCESS_TOKEN}
    />
  );
};

export default Experiments;
